const user ={
	name:"11",
	id:"11",

}
export default
{
 user,
}


// WEBPACK FOOTER //
// ./src/vuex/user.js